import { ApolloError } from '@apollo/client'
import { toast } from 'react-toastify'

export const toastApolloError = (e: ApolloError) => {
  toast.error(e.message.replace('msg:', ''))
}
